import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import PublicLayout from "../components/PublicLayout";

const PublicBlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [latestBlogs, setLatestBlogs] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [blogResponse, latestResponse] = await Promise.all([
          axiosInstance.get(`/get-blog/${slug}`),
          axiosInstance.get("/all-blogs-latest"),
        ]);
        setBlog(blogResponse.data?.blog || null);
        setLatestBlogs(latestResponse.data?.blogs || []);
      } catch (error) {
        console.error(error);
      }
    };

    load();
  }, [slug]);

  return (
    <PublicLayout>
      <Helmet>
        <title>{blog?.metaTitle || blog?.title || "Career Advice"}</title>
        <meta name="description" content={blog?.metaDescription || blog?.title || "Professional career advice"} />
      </Helmet>

      <section className="portal-section">
        <div className="portal-container">
          {!blog ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : (
            <div className="row gy-4">
              <div className="col-lg-8">
                <div className="portal-card p-3 p-md-4">
                  <span className="portal-kicker">Professional Insights</span>
                  <div className="portal-muted small fw-bold mb-2">
                    {blog.createdAt
                      ? new Date(blog.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                      : "Latest"}
                  </div>
                  <h1 className="portal-title mb-3">{blog.title}</h1>
                  <div
                    className="portal-muted leading-relaxed blog-content"
                    dangerouslySetInnerHTML={{ __html: blog.description || "" }}
                  />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="d-grid gap-3">
                  <div className="portal-card p-3">
                    <h2 className="h6 fw-bold mb-2">Latest Articles</h2>
                    <div className="d-grid gap-2">
                      {latestBlogs.slice(0, 5).map((item) => (
                        <div key={item.slug}>
                          <Link to={`/blogs/${item.slug}`} className="text-decoration-none text-dark fw-bold small hover-primary">
                            {item.title}
                          </Link>
                          <div className="portal-muted smallest mt-1">Read article</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="portal-card p-3">
                    <h3 className="h6 fw-bold mb-2">Ready for a change?</h3>
                    <p className="portal-muted small mb-3">
                      Discover curated roles that match your new insights.
                    </p>
                    <Link to="/jobs" className="portal-btn-primary w-100">Browse Jobs</Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
};

export default PublicBlogDetail;
